import { ENodeEnv } from "../shared/enum";

export const baseURL = process.env.NODE_ENV == ENodeEnv.Production ? '/api' : 'https://localhost:7190/api';
